import { render, staticRenderFns } from "./EditGoalBadge.vue?vue&type=template&id=c69511e8"
import script from "./EditGoalBadge.vue?vue&type=script&lang=js"
export * from "./EditGoalBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports